import AccessToken from '~/Api/Authentication/AccessToken';
import mapAccessToken from '~/Api/Authentication/mapAccessToken';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import ImpersonateLoginErrorResponse from './ImpersonateLoginErrorResponse';

export interface Result {
	accessToken: AccessToken;
}

export default async function impersonateLogin(client: ApiClient, targetUserId: string): Promise<Result> {
	try {
		const request = await client.fetch('authentication/impersonate/login', {
			method: 'POST',
			body: JSON.stringify({ targetUserId }),
		});
		const response = await request.json();
		return { accessToken: mapAccessToken(response.accessToken) };
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new ImpersonateLoginErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
}
